export default {

  dev: {
    host: "http://admin.3adiaoding.test/api",
    category_id: "1",
  },
  pro: {
    host: "https://admin.461yy.cn/api",
    category_id: "1",
  }
}



// WEBPACK FOOTER //
// ./src/env.js